import { createFileRoute } from "@tanstack/react-router";

import { SupplierPage } from "../../../../features/purchasing/supplier-page";

export const Route = createFileRoute("/_app/purchasing/suppliers/$id")({ component: Page });

function Page() {
  const { id } = Route.useParams();
  return <SupplierPage key={id} id={id} />;
}
